import { render, staticRenderFns } from "./ThePart1Main.vue?vue&type=template&id=ab94568e&scoped=true"
import script from "./ThePart1Main.vue?vue&type=script&lang=js"
export * from "./ThePart1Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart1Main.vue?vue&type=style&index=0&id=ab94568e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab94568e",
  null
  
)

export default component.exports